import { computed } from 'vue'
import { useRouter } from 'vue-router'
import type { HeaderProps } from '@el-plus/components/header'
import type { ButtonsProps } from '@el-plus/components/buttons'
import { mergeListByKey, gotoTaskTrace } from '@el-plus/utils'
import { useLocale } from '@el-plus/hooks/use-locale'
import { useNavigation } from '@el-plus/hooks/use-navigation'
export const useHeader = (props, emit) => {
  const router = useRouter()
  const isShowBack = computed(() => {
    if (!props.allowBack) {
      return false
    }
    if (window.parent.openMenuSelect) {
      return false
    }
    return true
  })
  const goBack = () => {
    router?.back()
  }
  return {
    isShowBack,
    goBack,
  }
}
export const useButtons = (props: HeaderProps, emit) => {
  const { t } = useLocale()
  const { mode: defaultMode } = useNavigation()
  const mode = computed(() => {
    return props.mode || defaultMode.value
  })
  let defaultButtons: ButtonsProps['list'] = [
    {
      name: t('ep.header.edit'),
      prop: 'edit',
      permission: props.name ? `${props.name}:UPDATE` : '',
      disabled: () => {
        return mode.value !== 'browse'
      },
    },
    {
      name: t('ep.header.save'),
      prop: 'save',
      permission: props.name ? `${props.name}:SAVE` : '',
      disabled: () => {
        return !(mode.value === 'edit' || mode.value === 'add')
      },
    },
    {
      name: t('ep.header.cancel'),
      prop: 'cancel',
      disabled: () => {
        return mode.value !== 'edit'
      },
    },
    {
      name: t('ep.header.refresh'),
      prop: 'refresh',
      permission: props.name ? `${props.name}:REFRESH` : '',
      disabled: () => {
        return mode.value !== 'browse'
      },
    },
    {
      name: t('ep.header.approvalLog'),
      prop: 'approvalLog',
      permission: props.name ? `${props.name}:APPROVALLOG` : '',
      show: () => {
        return !!props.workflowId
      },
      onClick: () => {
        gotoTaskTrace(props.workflowId!)
      },
    },
  ]
  // 过滤要显示的
  if (props.defaultButtons?.length) {
    defaultButtons = defaultButtons.filter((item) => {
      return props.defaultButtons!.some((item1) => item1 === item.prop)
    })
  }else if(props.defaultButtons?.length===0){
    defaultButtons = []
  }
  const buttons = mergeListByKey(defaultButtons, props.buttons)
  return {
    buttons,
  }
}
